<div class="filterContainer">
  <ng-template *ngIf="template" [ngTemplateOutlet]="template"></ng-template>
</div>
